import { SxProps } from '@mui/system';

export const imageContainer: SxProps = {
	'> img': {
		display: 'block',
		maxWidth: '100%',
		margin: 'auto',
	},
};
